export default "__VITE_ASSET__e3a4f93a__"